import {
  accountDetailsRequestHandler,
  addAccountRequestHandler,
  deleteAccountRequestHandler,
} from '../../Utilities/ApiRequestHandler';

interface APIFormData {
  accountName: string;
  webhook: string;
}

export async function addNewApiConnection(sessionId: string, apiPayload: APIFormData) {
  if (!sessionId || sessionId === '') return;

  const requestOptions = {
    body: JSON.stringify(apiPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await addAccountRequestHandler(`${process.env.REACT_APP_API_PATH}/connections/custom`, requestOptions);
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;

  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/custom/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_load_connection',
  );
}

export async function deleteAccount(accountId: string, sessionId: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;

  return await deleteAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/custom/${accountId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_remove_connection',
  );
}
